import {
  ComponentFactoryResolver, ComponentRef, Directive, Input, OnInit,
  ViewContainerRef
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig, FormBaseConfig, FormFieldComponent } from '../models/form-field.model';
import { FormInputComponent } from '../components/form-input/form-input.component';
import { FormButtonComponent } from '../components/form-button/form-button.component';
import { FormSelectComponent } from '../components/form-select/form-select.component';
import { FormDateComponent } from '../components/form-date/form-date.component';
import { FormRadioButtonComponent } from '../components/form-radio-button/form-radio-button.component';
import { FormCheckboxComponent } from '../components/form-checkbox/form-checkbox.component';
import { FormGroupComponent } from '../components/form-group/form-group.component';
import { FormConfigInstance } from '../services/form.service';
import { FormLabelComponent } from '../components/form-label/form-label.component';
import { FormDateRangeComponent } from '../components/form-date-range/form-date-range.component';
import { FormFileUploadComponent } from '../components/form-file-upload/form-file-upload.component';
import { FormControlsContainerComponent } from '../components/form-controls-container/form-controls-container.component';
import { FormSlideToggleComponent } from '../components/form-slide-toggle/form-slide-toggle.component';
import { FormSliderComponent } from '../components/form-slider/form-slider.component';
import { FormInjectComponent } from '../components/form-inject/form-inject.component';
import { FormEntityComponent } from '../components/form-entity/form-entity.component';
import { FormListPickerComponent } from '../components/form-list-picker/form-list-picker.component';
import { FormChipsComponent } from '../components/form-chips/form-chips.component';
import { FormColorComponent } from '../components/form-color/form-color.component';

const componentMapper = {
  input: FormInputComponent,
  button: FormButtonComponent,
  select: FormSelectComponent,
  date: FormDateComponent,
  radio: FormRadioButtonComponent,
  checkbox: FormCheckboxComponent,
  group: FormGroupComponent,
  label: FormLabelComponent,
  daterange: FormDateRangeComponent,
  fileUpload: FormFileUploadComponent,
  container: FormControlsContainerComponent,
  slideToggle: FormSlideToggleComponent,
  slider: FormSliderComponent,
  inject: FormInjectComponent,
  entity: FormEntityComponent,
  listPicker: FormListPickerComponent,
  chips: FormChipsComponent,
  color: FormColorComponent
};


@Directive({
  selector: '[gioFormField]'
})
export class FormFieldDirective implements OnInit {


  @Input() service: FormConfigInstance;
  @Input() field: FieldConfig;
  @Input() group: FormGroup;

  componentRef: ComponentRef<FormFieldComponent>;

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) { }


  ngOnInit() {
    const mapper = componentMapper[this.field.type];
    const factory = this.resolver.resolveComponentFactory<FormFieldComponent<any>>(
      mapper
    );
    this.componentRef = this.container.createComponent<FormFieldComponent>(factory);

    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;
    this.componentRef.instance.service = this.service;
    this.componentRef.instance.state = 'idle';
  }

}
